import React from "react";
import Spinner from "../../../../utils/loader/Spinner";
import {useForm} from "react-hook-form";
import {emailRegExp} from "../../../../../helpers/emailRegExp";
import {CustomerFactory} from "@connox/typescript-library";
import {getShopId} from "../../../../lib/getShopId";
import {useTranslation} from "react-i18next";
import styles from "../BrandOfTheMonthModal.module.scss";
import {useCustomerSelector} from "../../../../../store";

type FormState = {
  email: string;
};

const NewsletterForm: React.FC<{onSuccess: () => void}> = ({onSuccess}) => {
  const {customer} = useCustomerSelector();
  const {t} = useTranslation();
  const {
    formState: {errors, isSubmitting},
    register,
    handleSubmit,
  } = useForm<FormState>({mode: "onSubmit", defaultValues: {email: customer.email ?? ""}});

  const onSubmit = (data: FormState) => {
    const {email} = data;

    if (Object.keys(errors).length !== 0) {
      return;
    }

    return CustomerFactory.createOrUpdateCustomer(getShopId(), {email, newsletterFlag: true}).then(() => {
      onSuccess();
    });
  };

  return (
    <form className={styles.bomForm} noValidate onSubmit={handleSubmit(onSubmit)}>
      <input
        type="email"
        placeholder={t("form.yourEmailAddress")}
        className={errors.email ? styles.invalid : ""}
        {...register("email", {
          required: t("form.pleaseComplete"),
          pattern: {value: emailRegExp, message: t("form.typeInValidEmailAddress")},
        })}
      />
      {errors.email && <span className={styles.errorMessageInput}>{errors.email.message}</span>}
      <button type="submit"> {isSubmitting ? <Spinner /> : <>{t("newsletter.subscribeNow")}</>}</button>
    </form>
  );
};

export default NewsletterForm;
